<template>
    <div class="my-auto text-white">
        <h4 class="text-info">{{ $t('mfa.title') }}</h4>
        <p class="text-white mb-4">{{ message }}</p>
        <form @submit.prevent="handleSubmit" id="auth-form">
            <div class="mb-3">
                <label for="code" class="form-label">Code</label>
                <input class="form-control" type="code" required :placeholder="$t('mfa.codePlaceholder')" v-model="code">
            </div>
            <div class="d-grid mb-0 text-center">
                <button class="btn btn-info" type="submit">{{ $t('common.submit') }}</button>
            </div>
            <div class="mb-3" v-if="errorMessage">
                <div class="error-msg-displayed">
                {{ errorMessage }}
                </div>
            </div>
        </form>
    </div>
    <!-- Footer-->
    <footer class="footer footer-alt">
<p class="text-white">{{ $t('logout.backTo') }} <router-link to="/login" class="text-sidebar-link ms-1"><b>{{ $t('common.backToLogin') }}</b></router-link></p>
    </footer>
</template>

<script>
import { useUserStore } from '@/stores/userStore';
import { useRouter, useRoute } from 'vue-router';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

export default {
    name: 'MFAPage',
    setup() {
        const userStore = useUserStore();
        const router = useRouter();
        const route = useRoute();
        const { t } = useI18n();
        const uuid = route.query.uuid;
        const type = route.query.type;
        const message = ref(userStore.mfa_info.message);
        const code = ref(null);
        const errorMessage = ref("");

        const handleSubmit = async() => {
            try {
                if(uuid) {
                    await userStore.mfaChangePassword(uuid, code.value, type);
                    router.push({ path: "/result", query: {success: true, title: t('common.done'), message: t('changepwd.passwordChanged')}});
                } else {
                    const path = await userStore.mfaLogin(code.value);
                    router.push({ path: path });
                }
            } catch (error) {
                errorMessage.value = error;
            }
        }

        return {
            handleSubmit,
            message,
            code,
            errorMessage,
        };
    },
}
</script>
